import { NgModule, Self } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { SelfRegistrationComponent } from './components/self-registration/self-registration.component';
import { RmsPaymentCheckoutComponent } from './components/classified/rms-payment-checkout/rms-payment-checkout.component';
import { RmsPaymentSuccessComponent } from './components/classified/rms-payment-success/rms-payment-success.component';
import { RmsInboxComponent } from './components/classified/rms-inbox/rms-inbox.component';
import { SspSelfRegistrationComponent } from './components/self-registration/ssp-self-registration/ssp-self-registration.component';
import { EmailApprovalInboxComponent } from './components/classified/email-approval-inbox/email-approval-inbox.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    data:{
      breadcrumb: []
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data:{
      breadcrumb:[]
    }
  },
  { 
    path: 'resetPassword',
    component: LoginComponent,
    data:{
      breadcrumb:[]
    }
  },
  {
    path: 'selfRegistration',
    component: SelfRegistrationComponent,
    data:{
      breadcrumb:[]
    }
  },
  {
    path: 'sspselfRegistration',
    component: SspSelfRegistrationComponent,
    data:{
      breadcrumb:[]
    }
  },
  {
      path:'rmscheckout',
      component:RmsPaymentCheckoutComponent,
      data:{
        breadcrumb:[]
      }
  },
  {
    path:'rmswfinbox',
    component:EmailApprovalInboxComponent,
    data:{
      breadcrumb:[]
    }
},
  {
    path:'rms/paymentStatus',
    component:RmsPaymentSuccessComponent
},
  {
    path: '',
    component: DefaultLayoutComponent,
    children:[
      {
        path: 'landingpage',
        component: LandingPageComponent,
        data:{
          breadcrumb: []
        }
      },
      {
        path:'dashboard',
        loadChildren: () => import('./components/dashboard/dashboard.module').then(dashboard => dashboard.DashboardModule),
        data:{
          breadcrumb: []
        }
      },
      {
        path:'admin',
        loadChildren: () => import('./components/user-management/user-management.module').then(userManagement => userManagement.UserManagementModule),
        data:{
          breadcrumb: []
        }
      },
      {
        path:'mastersModal',
        loadChildren: () => import('./components/masters/masters.module').then(master => master.MastersModule),
        data:{
          breadcrumb: []
        }
      },
      {
        path:'classified',
        loadChildren: () => import('./components/classified/classified.module').then(classified => classified.ClassifiedModule),
        data:{
          breadcrumb: []
        }
      },
      {
        path:'rms',
        loadChildren: () => import('./components/classified/rms-inbox/rms.module').then(classified => classified.RmsModule),
        data:{
          breadcrumb: []
        }
      },
      {
        path:'display',
        loadChildren: () => import('./components/classified/classified.module').then(classified => classified.ClassifiedModule),
        data:{
          breadcrumb: []
        }
      },{
        path:'workflow',
        loadChildren: () => import('./components/classified/classified.module').then(classified => classified.ClassifiedModule),
        data:{
          breadcrumb: []
        }
      },{
        path:'manageda',
        loadChildren: () => import('./components/masters/masters.module').then(manageda => manageda.MastersModule),
        data:{
          breadcrumb: []
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
